import React from 'react';
import styled from 'styled-components';
import moment from 'moment-timezone';
import { useDispatch, useSelector } from 'react-redux';

import { Button, Animation, PopOut } from 'components'
import { FaEllipsisH } from 'react-icons/fa'
import Options from './Options'
import {WorkflowTile} from '../WorkflowTile'
import { AnimatePresence } from 'framer-motion'

import { clientContext } from 'context';
import classes from './ClientTile.module.css';

const defaultStyle = {
    backgroundColor: 'var(--secondary-color)',
    subtitleColor: 'var(--secondary-accent-color)',
    padding: '1rem 1.5rem',
    margin: '0.5rem 0'
}

const iconStyle = {
    width:'2rem', 
    height:'2rem',
    objectFit:'contain', 
}

const Container = styled.div`
    background-color: ${props => props.styles.backgroundColor};
    border-radius: 5px;
    box-shadow: var(--box-shadow);
    padding: ${props => props.styles.padding};
    margin: ${props => props.styles.margin};
    display: grid;
    grid-template-columns: min-content minmax(0, 1fr) min-content;
    align-items: center;
`

const Icon = styled.div`
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: inherit;
`

const Title = styled.div`
    font-weight: bold;
    color: ${props => props.styles.titleColor};
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
`

const Subtitle = styled.div`
    font-size: 0.8rem;
    color: ${props => props.styles.subtitleColor};
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
`

const Wrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    margin: 0 0 0 1rem;
`

const DialogueContainer = styled.div`
    background-color: var(--secondary-color);
    border: 1px solid var(--primary-accent-color);
    border-radius: 5px;
    padding: 1rem;
    box-shadow: var(--box-shadow);
    display: flex;
    flex-direction: column;
`

const Row = styled.div`
    display: flex;
`

const Section = styled.div`
    width: 100%;
    grid-column: 1/4;
    margin-top: 1rem;
`

const Placeholder = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    /* border: 1px solid var(--secondary-accent-color); */
    background-color: var(--primary-color);
    padding: 1rem;
    color: var(--secondary-accent-color);
    /* font-weight: bold; */
`


const ClientTile = props => {
    const {
        client,
        styles,
        onDelete,
        onEditWorkflow
    } = props;
    const [open, setOpen] = React.useState(false);
    const dispatch = useDispatch();
    const updatedStyle = Object.assign({}, defaultStyle, styles);
    const workflows = useSelector((state) => state.integration.workflows)
    const user = useSelector((state) => state.auth.user)
    const timezone = user['timezone']

    const getWorkflowBlocks = () => {
        let blocks = []
        workflows && Object.values(workflows).map(workflow => {
            if(workflow['userId'] === client['userId'] & workflow.trigger['client'] === client['client'] & workflow.trigger['clientId'] === client['clientId']){
                blocks.push(<WorkflowTile workflow={workflow} disableIcon disableCreateDate disableShowMore
                                onEdit={() => onEditWorkflow(workflow)}
                                styles={{backgroundColor: 'var(--primary-color)', secondaryColor: 'var(--secondary-color)', padding: '0.5rem', gridTemplateColumns: 'minmax(0, 1fr) min-content min-content'}}/>)
            }
        })
        blocks.length === 0 && blocks.push(<Placeholder>No workflows created yet</Placeholder>)
        return blocks
    }
    getWorkflowBlocks()
    return (
        <PopOut trigger='rightClick' point element={<Options open={open} onOpen={() => setOpen(!open)} onDelete={onDelete}/>}>
            <div className={classes.Container}>
                <div className={classes.Section}>
                    <Icon onClick={() => setOpen(!open)}><img src={clientContext[client['client']]['icon']['value']} style={iconStyle}/></Icon>
                    <Wrapper onClick={() => setOpen(!open)}>
                        <Title styles={updatedStyle}>{client['clientTitle']}</Title>
                        <Subtitle styles={updatedStyle}>{`${clientContext[client['client']]['title']} - Added ${moment(client['created']).tz(timezone).format('MMM D Y')}`}</Subtitle>
                    </Wrapper>
                    <div className={classes.Button}>
                        <Button icon={<FaEllipsisH style={{color: 'var(--secondary-accent-color'}}/>}
                            styles={{backgroundColor: 'var(--secondary-color)', padding: '0.5rem', margin: 0, boxShadowColor: 'transparent'}}
                            contextMenu={<Options open={open} onOpen={() => setOpen(!open)} onDelete={onDelete}/>} placement='bottom-end'
                            />
                    </div>
                </div>
                <AnimatePresence>
                    {open && 
                    <Animation animation='expand' style={{gridColumn: '1/4'}}>
                        <Section>
                            {getWorkflowBlocks()}
                        </Section>
                    </Animation>}
                </AnimatePresence>
            </div>
        </PopOut>
    )
}

export default ClientTile;